import { useFlag } from '@/components/posthog-provider';
import { useListCalendarAccounts } from '@/features/integrations/api';

/** Rollout controls new setup; a saved connection remains available to its owner. */
export function useCalendarIntegrationEnabled(): boolean {
  const enabled = useFlag('rollout-calendar-integration');
  const { accounts, isAvailable } = useListCalendarAccounts({
    includeMeetOnly: true,
  });
  return enabled || isAvailable || accounts.length > 0;
}
